import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
// import { EquipoAdicional } from "@/shared/components/erp/EquipoAdicional";
// import { CustomAutocompleteArrStringNoForm, SampleTable } from "@/shared/components/ui";

// import { useUiStore } from "@/store/ui";
// import SelectSerieONTOTInstallTectActivacion from "./SelectSerieONTOTInstallTectActivacion";
import { Grid, Typography } from "@mui/material";
// import ModalProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalProductoSelectComponente";
// import { MaterialesKey } from "@/store/erp";
// import { EquiposUtilizadosInstallOTTecAsig } from "@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos";
import { EquiposAdicionalesParaVenta } from "./EquiposAdicionalesParaVenta";
// import { EquiposUtilizadosInstallOTTecAsig, MaterialesUtilizadosInstallOTTecAsig } from "@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos";
// import { gridSize } from "@/shared";
// import { SampleCheckbox, TabTextLabel } from "@/shared/components/ui";
import { OrdenTrabajo, TipoInstalacion } from "@/shared/interfaces";
import { CustomAutocomplete, CustomAutocompleteArrString, TabTextLabel } from "@/shared/components/ui";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";

// import { EquipoAdicionalPreventaBooleans } from "@/erp/operaciones/preagendamiento/shared/components";

export type ActivacionInstallOTHoraInitFinFormTabProps = {
  form?: any;
  ordenTrabajo?: OrdenTrabajo;
};

const ActivacionInstallOTHoraInitFinFormTab: React.FC<
  ActivacionInstallOTHoraInitFinFormTabProps
> = ({ form }) => {

  const typInstalation = useTypeInstalation((s) => s.typInstalation);
  const isLoadingTypeInstalation = useTypeInstalation(
    (s) => s.isLoadingTypeInstalation
  );
  // const setAlert = useUiStore((s) => s.setAlert);

  

  // const { getCategoriaProducto } = useCategoriaProductoStore();
  // const addSelectedItemProducto = useMaterialesUtilizadosStore(
  //   (s) => s.addSelectedItemProducto
  // );
  // const equiposAdicionales = useMaterialesUtilizadosStore(
  //   (s) => s.equiposAdicionales
  // );
  // const addSelectedItemProducto = useMaterialesUtilizadosStore(
  //   s => s.addSelectedItemProducto
  // );
  // const { columnsItemMaterialEquipoAdicional } = useTableColumnsInventario({
  //   key: MaterialesKey.equiposAdicionales,
  // });
  // const productos = useEquiposAdicionales(s => s.productos)
  // const handleAgregarProducto = useEquiposAdicionales(s => s.handleAgregarProducto)
  // const handleActualizarProducto = useEquiposAdicionales(s => s.handleActualizarProducto)
  // const getDataProducto = useEquiposAdicionales(s => s.getDataProducto)
  // const handleEliminarProducto = useEquiposAdicionales(s => s.handleEliminarProducto)
  // useEffect(() => {
  //   getCategoriaProducto({})
  // }, []);

  return (
    <>

      <Grid {...gridSizeMdLg12} container spacing={2}>
        <CustomAutocomplete<TipoInstalacion>
          size={gridSizeMdLg12}
          label={"Tipo de Instalación"}
          name="tipo_instalacion"
          // options
          options={typInstalation || []}
          valueKey="nombre" // name is the fk
          actualValueKey="codigo"
          defaultValue={form.getValues().tipo_instalacion || ""}
          isLoadingData={isLoadingTypeInstalation}
          // validation
          control={form.control}
          error={form.formState.errors.tipo_instalacion}
          helperText={form.formState.errors.tipo_instalacion?.message}
          onChangeValue={(e) => {
            form.setValue('tipo_instalacion', e)
          }}
        />

        {
          form.watch("tipo_instalacion") == "EMPAQUETADO" ? (
            <CustomAutocompleteArrString
              size={gridSizeMdLg12}
              label={"Subtipo de Instalación"}
              name="subtipo_instalacion"
              // options
              options={[
                "TIPO 1",
                "TIPO 2",
                "TIPO 3"
              ]}
              defaultValue={form.getValues().subtipo_instalacion || ""}
              isLoadingData={false}
              // validation
              control={form.control}
              error={form.formState.errors.subtipo_instalacion}
              helperText={form.formState.errors.subtipo_instalacion?.message}
              onChangeValue={(e) => {
                form.setValue('subtipo_instalacion', e)
              }}
            />
            
          ) : null
        }

        <TabTextLabel text="Puntos de Red" />
        
        <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label={"Puntos de Red Instalados"}
          name="puntos_red_instalados"
          // options
          options={[
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
          ]}
          defaultValue={form.getValues().puntos_red_instalados || "0"}
          isLoadingData={false}
          // validation
          control={form.control}
          error={form.formState.errors.puntos_red_instalados}
          helperText={form.formState.errors.puntos_red_instalados?.message}
          onChangeValue={(e) => {
            form.setValue('puntos_red_instalados', e)
          }}
        />
        
        <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label={"Puntos de Red No Instalados"}
          name="puntos_red_no_instalados"
          // options
          options={[
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
          ]}
          defaultValue={form.getValues().puntos_red_no_instalados || "0"}
          isLoadingData={false}
          // validation
          control={form.control}
          error={form.formState.errors.puntos_red_no_instalados}
          helperText={form.formState.errors.puntos_red_no_instalados?.message}
          onChangeValue={(e) => {
            form.setValue('puntos_red_no_instalados', e)
          }}
        />

      </Grid>


      <Grid container item>
        {/* {
          form?.getValues()?.equipos_utilizados && form?.getValues()?.equipos_utilizados?.length > 0?
          <EquiposUtilizadosInstallOTTecAsig form={form} control={form.control} 
          ubicacion={form?.getValues()?.flota_data?.ubicacion!} onlyShow showToActivaciones />
          :
          <EquiposUtilizadosInstallOTTecAsig control={form.control} 
          ubicacion={form?.getValues()?.flota_data?.ubicacion!} />
        } */}
        {/* onlyShow showToActivaciones={true} */}
        {/* <SelectSerieONTOTInstallTectActivacion /> */}
      </Grid>



      <Grid {...gridSizeMdLg12} container item gap={1}>
        <Grid {...gridSizeMdLg6} alignContent={"center"}>
          <Typography variant="h6">Equipos Adicionales para la Venta</Typography>
        </Grid>
      </Grid>

      <EquiposAdicionalesParaVenta form={form} onlyShow/>
      
      {/* <TabTextLabel text="SERIE" /> */}
      {/* <SampleCheckbox
        label="Habilitar equipos adicionales"
        name="actualizar_nodo_olt"
        control={form.control}
        defaultValue={!!form.getValues().actualizar_nodo_olt || false}
        size={gridSize}
        disabled={form.watch("router") ? false : true}
        onClickDisabled={() => {
          setAlert(
            true,
            "Debe completar todos los datos correspondientes a detalle de activación para habilitar los equipos adicionales.",
            AlertSeverityEnum.warning
          );
        }}
      /> */}
      {/* ------- Equipo Adicional -------- */}
      {/* {form.watch("actualizar_nodo_olt") ? (
        <>
          <TabTextLabel text="Equipo Adicional" pt="48px" />
          <EquipoAdicional form={form} editSupervisor={true} />
        </>
      ) : null} */}
      

      {/* ------- materiales - serie -------- */}

      {/* =============== EQUIPOS UTILIZADOS =============== */}

      {/* =============== MATERIALES UTILIZADOS =============== */}
      {/* <MaterialesUtilizadosInstallOTTecAsig form={form} 
      ubicacion={form?.getValues()?.flota_data?.ubicacion!} onlyShow={true} /> */}
    </>
  );
};

export default ActivacionInstallOTHoraInitFinFormTab;
